import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const ActionModal = ({
  show,
  handleHide,
  title,
  text,
  confirmBtn,
  confirmAction,
}) => {
  const { t: translator } = useTranslation();
  useEffect(() => {}, [confirmBtn]);
  return (
    <Modal show={show} onHide={handleHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{translator(title)}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{translator(text)}</p>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-outline-secondary"
          data-dismiss="modal"
          onClick={handleHide}
        >
          {translator("Users-DeleteModal-Cancel")}
        </button>
        {confirmBtn != "" && (
          <button
            onClick={confirmAction}
            type="button"
            className="btn btn-primary"
          >
            {translator(confirmBtn)}
          </button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default ActionModal;
